import { dateFormatter } from "../../../utils/tableDataFormatter";

const valueLanguageFormatter = (params, translatedRowData, key) => {
  const type = params.data[key];
  const value =
    translatedRowData && translatedRowData[key]
      ? translatedRowData[key][type]
      : type;
  return value;
};
export const RELACEMENT_ANALYSIS_COL_DEF = (t, translatedRowData) => [
  {
    headerName: t("ReplacementAnalysisStrings.forecasted_date"),
    field: "forecasted_date",
    sortable: true,
    flex: 1,
    valueFormatter: dateFormatter,
  },
  {
    headerName: t("ReplacementAnalysisStrings.trigger"),
    field: "trigger",
    sortable: true,
    flex: 1,
    valueFormatter: (params) =>
      valueLanguageFormatter(params, translatedRowData, "trigger"),
    valueGetter: (params) =>
      valueLanguageFormatter(params, translatedRowData, "trigger"),
  },
  {
    headerName: t("ReplacementAnalysisStrings.explanation"),
    field: "explanation",
    sortable: true,
    flex: 1,
    valueFormatter: (params) =>
      valueLanguageFormatter(params, translatedRowData, "explanation"),
    valueGetter: (params) =>
      valueLanguageFormatter(params, translatedRowData, "explanation"),
  },
];
